import { render, staticRenderFns } from "./BaseListItem.vue?vue&type=template&id=028e1c63&scoped=true&"
import script from "./BaseListItem.vue?vue&type=script&lang=js&"
export * from "./BaseListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e1c63",
  null
  
)

export default component.exports